module.exports = ".list-example-row {\r\n    padding: 0px 12px;\r\n}"